(() => {
 if(customElements.get('flaay-full-menu'))return;
 class FlaayFullMenu extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();const options={signal:this.abort.signal};
   this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-menu-open]');
   this.trigger.addEventListener('click',()=>this.open(),options);
   this.querySelector('[data-menu-close]').addEventListener('click',()=>this.dialog.close(),options);
   this.dialog.addEventListener('close',()=>this.cleanup(),options);
   this.dialog.addEventListener('click',e=>{
    const department=e.target.closest('[data-department]');
    if(department){
     const id=department.dataset.department;
     this.querySelectorAll('[data-department]').forEach(button=>button.setAttribute('aria-pressed',String(button===department)));
     this.querySelectorAll('[data-department-panel]').forEach(panel=>panel.hidden=panel.dataset.departmentPanel!==id);
     this.querySelector('.flaay-menu__scroll').scrollTop=0;
    }else if(e.target.closest('a[href]'))this.dialog.close();
   },options);
   document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)||e.target.contains(this))this.open();},options);
   document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(this))this.dialog.close();},options);
  }
  open(){if(this.dialog.open)return;this.dialog.showModal();this.trigger.setAttribute('aria-expanded','true');document.documentElement.classList.add('flaay-menu-open');}
  cleanup(){this.trigger.setAttribute('aria-expanded','false');document.documentElement.classList.remove('flaay-menu-open');if(this.isConnected)this.trigger.focus({preventScroll:true});}
  disconnectedCallback(){if(this.dialog?.open){this.dialog.close();this.cleanup();}this.abort?.abort();}
 }
 customElements.define('flaay-full-menu',FlaayFullMenu);
})();
